import type { ReactNode } from "react";
import type { AuthenticatedUser } from "../api/auth.js";
import type { LaunchpadTile } from "../components/Launchpad/Launchpad.js";

interface GlobalApplication {
  id: string;
  tile: LaunchpadTile;
  route: {
    path: string;
    element: ReactNode;
  };
  isVisible?: (context: { currentUser?: AuthenticatedUser }) => boolean;
}

// AI Assistant removed - managed via database
const GLOBAL_APPLICATIONS: GlobalApplication[] = [];

export function getGlobalTenantApplications(context: { currentUser?: AuthenticatedUser }): GlobalApplication[] {
  return GLOBAL_APPLICATIONS.filter((application) => {
    if (!application.isVisible) {
      return true;
    }
    return application.isVisible(context);
  });
}

export function getGlobalLaunchpadTiles(context: { currentUser?: AuthenticatedUser }): LaunchpadTile[] {
  return getGlobalTenantApplications(context).map((application) => application.tile);
}

export function getGlobalRoutes(context: { currentUser?: AuthenticatedUser }): Array<GlobalApplication["route"]> {
  return getGlobalTenantApplications(context).map((application) => application.route);
}
